export default __webpack_public_path__ + "static/media/WEB_DE.d4b2ba6c.png";